<template>
  <div class="app-container editForm">
    <div class="detailHead">
      <div class="title">
        <img src="@/assets/images/accident/location.png" alt=""/>
        <span
          style="
            color: #9098a3;
            font-size: 16px;
            vertical-align: top;
            margin-left: 5px;
          "
        >调解管理 > {{ accidentTitle }}</span
        >
      </div>
      <div class="btnGroup">
        <button class="back" @click="() => $router.push('/index')">
          <img src="@/assets/images/accident/back.png"/>返回
        </button>
      </div>
    </div>
    <div class="accident-edit">
      <div class="left-content">
        <!-- 视频 -->
        <div class="videolists" v-if="!($route.name === 'mediatorInfo')">
          <div :class="selectdVideo === index ? 'videoselected changvideobtn':'changvideobtn'"
               v-for="(item,index) in videoArr" :key="item" @click="changVideo(index)"
          >视频{{ index + 1 }}
          </div>
        </div>
        <stream-video :accident="accident" v-if="$route.name === 'mediatorInfo'" ref="video"/>
        <video-record v-else ref="video" :accident="accident"/>
      </div>
      <!-- 案件图片列表 -->
      <div class="right-content">
        <div class="hospitalList">
          <!--          <img src="@/assets/images/list/ang1.png" :class="ang1"/>-->
          <!--          <img src="@/assets/images/list/ang2.png" :class="ang2"/>-->
          <!--          <img src="@/assets/images/list/ang3.png" class="ang3"/>-->
          <!--          <img src="@/assets/images/list/ang4.png" class="ang4"/>-->
          <div class="maincontent">

            <div class="processcontent" style="margin-left: 0;color: #b1e3ff;">
              <h2 style="text-align: center">调解详情</h2>
              <div class="center" style="margin-bottom: 20px" v-if="mainValue && mainValue.accidentInfo">

                <p>案件编号：<span style="display: inline-block;width: 180px;">{{
                    mainValue.recordId
                  }}</span></p>
                <p>事故时间: <span style="display: inline-block;width: 180px;">{{
                    mainValue.accidentInfo.accidentTime
                  }}</span>
                  事故地点: <span>{{ mainValue.accidentInfo.accidentAddress }}</span></p>
                <p>处理部门: <span style="display: inline-block;width: 180px;">{{
                    mainValue.accidentInfo.department
                  }}</span>
                  事故责任认定书：<a style="color: #00afff" target="_blank" :href="mainValue.accidentInfo.liabilityUrl">点击查看</a>
                </p>

                <p>调解类型：<span style="display: inline-block;width: 180px;">{{
                    mainValue.mediationType | typeFilter
                  }}</span>调解方式：<span style="display: inline-block;width: 180px;">{{
                      mainValue.mediationCategory | categoryFilter
                    }}</span></p>
                <p>调解状态：<span style="display: inline-block;width: 180px;">{{
                    mainValue.status | statusFilter
                  }}</span>调解诉求：<span style="display: inline-block;width: 180px;">{{
                    mainValue.applicantReq
                  }}</span></p>
                <p>纠纷描述：<span style="display: inline-block;width: 180px;">{{
                    mainValue.disputeDesc
                  }}</span></p>
                <el-table v-if="mainValue.personInfos"
                          :data="mainValue.personInfos"
                          style="width: 100%"
                >
                  <el-table-column
                    prop="personType"
                    label="类型"
                  >
                    <template slot-scope="scope">
            <span v-if="scope.row.category == 0">
              申请人
            </span>
                      <span v-else>
              被申请人
            </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="姓名"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="personType"
                    label="类型"
                  >
                    <template slot-scope="scope">
            <span v-if="scope.row.personType == 0">
              自然人
            </span>
                      <span v-else-if="scope.row.personType == 1">
              法人
            </span>
                      <span v-else-if="scope.row.personType == 2">
              其他组织
            </span>
                      <span v-else>
              其他
            </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="phone"
                    label="电话"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="gender"
                    label="性别"
                  >
                    <template slot-scope="scope">
            <span v-if="scope.row.gender == 0">
              男
            </span>
                      <span v-else>
              女
            </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="callOutRes"
                    label="证件类型"
                  >
                    <template slot-scope="scope">
            <span v-if="scope.row.idType == 0">
              身份证
            </span>
                      <span v-else-if="scope.row.idType == 1">
              临时身份证
            </span>
                      <span v-else-if="scope.row.idType == 2">
              户口簿
            </span>
                      <span v-else-if="scope.row.idType == 3">
              军官证
            </span>
                      <span v-else-if="scope.row.idType == 4">
              警官证
            </span>
                      <span v-else>
              港澳通行证
            </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="idNum"
                    label="证件号"
                  >
                  </el-table-column>
                </el-table>

                <el-form :model="mediatorResult"
                         :rules="rules"
                         class="form-input-width" style="margin-top: 10px;"
                         :disabled="!mediatorResult && !mediatorResult.recordId"
                >
                  <el-form-item label="调解结果">
                    <el-select v-model="mediatorResult.mediationResult" prop="mediationResult" placeholder="请选择"
                               clearable
                    >
                      <el-option v-for="item in mediationResultList" :key="item.value" :label="item.label"
                                 :value="item.value"
                      >

                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="履行方式">
                    <el-select v-model="mediatorResult.performanceMode" prop="performanceMode" placeholder="请选择"
                               clearable
                    >
                      <el-option v-for="item in performanceModeList" :key="item.value" :label="item.label"
                                 :value="item.value"
                      >

                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="协议日期">
                    <el-date-picker
                      v-model="mediatorResult.agreeDate"
                      type="datetime"
                      placeholder="选择时间"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item label="涉案金额">
                    <el-input type="number" v-model="mediatorResult.amount" prop="amount">
                    </el-input>
                  </el-form-item>

                  <el-form-item label="协议内容">
                    <el-input type="textarea" v-model="mediatorResult.agreeContext">
                    </el-input>
                  </el-form-item>
                </el-form>
                <div class="proBtns" style="position: relative">
                  <!--                <div class="proCancle" @click="directCompensationCancle">取消</div>-->
                  <div class="proConfire" @click="directCompensation">确认</div>
                </div>
              </div>

              <div class="center" style="color: #b1e3ff;margin-bottom: 20px" v-else>
                <el-form :model="mediatorInfo"
                         class="form-input-width" style="margin-top: 10px;"
                >
                  <p style="width: 100%;background-color: #0B2756;padding: 5px">事故信息</p>
                  <el-form-item label="事故时间">
                    <el-date-picker
                      v-model="mediatorInfo.accidentInfo.accidentTime"
                      type="datetime"
                      placeholder="选择时间"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item label="事故地点">
                    <el-input type="textarea"  v-model="mediatorInfo.accidentInfo.accidentAddress" >
                    </el-input>
                  </el-form-item>

                  <el-form-item label="处理部门">
                    <el-input  v-model="mediatorInfo.accidentInfo.department" >
                    </el-input>
                  </el-form-item>

                  <el-form-item label="备注">
                    <el-input type="textarea" v-model="mediatorInfo.accidentInfo.liabilityUrl">
                    </el-input>
                  </el-form-item>

                  <p style="width: 100%;background-color: #0B2756;padding: 5px">申请人</p>
                  <el-form-item label="申请人类型">
                    <el-select v-model="mediatorInfo.applicantInfo.personType" prop="performanceMode" placeholder="请选择"
                               clearable
                    >
                    <el-option v-for="item in personTypeList" :key="item.value" :label="item.label"
                               :value="item.value"
                    ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="姓名">
                    <el-input v-model="mediatorInfo.applicantInfo.name" prop="amount">
                    </el-input>
                  </el-form-item>

                  <el-form-item label="性别">
                    <el-select v-model="mediatorInfo.applicantInfo.gender" prop="performanceMode" placeholder="请选择"
                               clearable
                    >
                      <el-option v-for="item in genderList" :key="item.value" :label="item.label"
                                 :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="联系方式">
                    <el-input type="number" v-model="mediatorInfo.applicantInfo.phone">
                    </el-input>
                  </el-form-item>
                  <el-form-item label="证件类型">
                    <el-select v-model="mediatorInfo.applicantInfo.idType" prop="performanceMode" placeholder="请选择"
                               clearable
                    >
                      <el-option v-for="item in idTypeList" :key="item.value" :label="item.label"
                                 :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="证件号">
                    <el-input v-model="mediatorInfo.applicantInfo.idNum" prop="amount">
                    </el-input>
                  </el-form-item>

                  <p style="width: 100%;background-color: #0B2756;padding: 5px">被申请人</p>
                  <el-form-item label="申请人类型">
                    <el-select v-model="mediatorInfo.person2.personType" prop="performanceMode" placeholder="请选择"
                               clearable
                    >
                      <el-option v-for="item in personTypeList" :key="item.value" :label="item.label"
                                 :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="姓名">
                    <el-input v-model="mediatorInfo.person2.name" prop="amount">
                    </el-input>
                  </el-form-item>

                  <el-form-item label="性别">
                    <el-select v-model="mediatorInfo.person2.gender" prop="performanceMode" placeholder="请选择"
                               clearable
                    >
                      <el-option v-for="item in genderList" :key="item.value" :label="item.label"
                                 :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="联系方式">
                    <el-input type="number"  v-model="mediatorInfo.person2.phone">
                    </el-input>
                  </el-form-item>
                  <el-form-item label="证件类型">
                    <el-select v-model="mediatorInfo.person2.idType" prop="performanceMode" placeholder="请选择"
                               clearable
                    >
                      <el-option v-for="item in idTypeList" :key="item.value" :label="item.label"
                                 :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="证件号">
                    <el-input v-model="mediatorInfo.person2.idNum" prop="amount">
                    </el-input>
                  </el-form-item>

                  <p style="width: 100%;background-color: #0B2756;padding: 5px">调解信息</p>
                  <el-form-item label="调解类型">
                    <el-select v-model="mediatorInfo.recordInfo.mediationType" prop="performanceMode" placeholder="请选择"
                               clearable
                    >
                      <el-option v-for="item in mediationTypeList" :key="item.value" :label="item.label"
                                 :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="调解方式">
                    <el-select v-model="mediatorInfo.recordInfo.mediationCategory" prop="performanceMode" placeholder="请选择"
                               clearable
                    >
                      <el-option v-for="item in mediationCategoryList" :key="item.value" :label="item.label"
                                 :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="纠纷描述">
                    <el-input type="textarea" v-model="mediatorInfo.recordInfo.disputeDesc">
                    </el-input>
                  </el-form-item>

                  <el-form-item label="申请人诉求">
                    <el-input type="textarea" v-model="mediatorInfo.recordInfo.applicantReq">
                    </el-input>
                  </el-form-item>

                </el-form>

                <div class="proBtns" style="position: relative">
                  <!--                <div class="proCancle" @click="directCompensationCancle">取消</div>-->
                  <div class="proConfire" @click="mediatorSubmit">确认</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Photos from '../components/Photos'
import insurancePhoto from '../components/insurancePhoto'
import BasicInfoForm from '../components/BasicInfoForm'
import OperationRecord from '../components/OperationRecord'
import VideoRecord from '../components/VideoRecord'
import StreamVideo from '../components/StreamVideo'
import AccidentPartys from '../components/AccidentPartys'
import {api} from '@/plugins/api'
import {req, getHospitalList, getMediatorList, getMediatorInfo, createMediatorInfo, createMediatorResult} from '@/api/accident/list'

import Liability from '../components/Liability'
import Claim from '../components/Claim'
// import UploadStatement from '../components/UploadStatement';
import SmsDialog from '@/views/accident/edit/sms-dialog'
import DictSelect from '../components/dict-select.vue'
import {offlineProcessing} from '@/api/accident/upload'
import claimsSelect from '@/views/accident/components/claimsSelect'
import {get} from '@/utils/dict'
import detailStyle from '@/views/accident/components/detailStyle.vue'
import '../common.less'
import pliceCascader from '@/views/accident/components/pliceCascader'
import axios from 'axios'
import myDialog from '@/components/custom/myDialog.vue'
import Edit from '../edit/editForm'
// import accidentData from '../components/a.json';
export default {
  name: 'mediatorInfo',
  components: {
    SmsDialog,
    myDialog,
    VideoRecord,
    Photos,
    BasicInfoForm,
    OperationRecord,
    AccidentPartys,
    Liability,
    Claim,
    StreamVideo,
    DictSelect,
    insurancePhoto,
    claimsSelect,
    detailStyle,
    pliceCascader
    // UploadStatement,
  },
  beforeRouteEnter(to, from, next) {
    next()
  },
  beforeRouteLeave(to, from, next) {
    // 只要退出房间则调用离开房间操作
    if (!this.$refs.video.isStreams()) {
      sessionStorage.setItem('exitId', from.params.id)
    }
    this.$refs.video.leave().then(() => {
      api.video.trtc.ready.r().then((res) => {
        if (res.code === '200') {
          // this.$store.commit(Mutations.CHANGE_READY_STATE); // 修改就绪样式
        }
      }) // 就绪请求
      next()
    })
    localStorage.setItem('isReady', '1')
  },
  beforeRouteUpdate(to, from, next) {
    this.$confirm('确定离开当前房间？')
      .then(() => {
        this.$refs.video.leave().then(() => {
          next()
        })
      })
      .catch(() => {
        next(false)
      })
  },
  props: {
    selectedAccidents: {
      type: Array,
      required: false,
    },
    pagination: {
      type: Object,
      default: () => ({
        page: 1,
        size: 6,
        total: 0,
      }),
    },
  },
  provide() {
    return {
      targetRefs: this.$refs,
      isDisabled: this.isDisabled,
      accident: this.accident,
      checkList: () => this.checkList
    }
  },
  data() {
    return {
      loading: false,
      accident_status: [],
      mediatorId: '',
      activeParty: '0',
      smsDialogVisible: false,
      mediationTypeList: [
        {
          label: '人民调解',
          value: '0',
        },
        {
          label: '行政调解',
          value: '1',
        }
      ],
      mediationCategoryList: [
        {
          label: '视频调解',
          value: '0',
        },
        {
          label: '线下调解',
          value: '1',
        }
      ],
      mediationResultList: [
        {
          label: '调解成功',
          value: '0',
        },
        {
          label: '调解不成功',
          value: '1',
        },
        {
          label: '继续调解',
          value: '2',
        }
      ],
      performanceModeList: [
        {
          label: '一次性赔偿',
          value: '0',
        },
        {
          label: '分期支付',
          value: '1',
        }
      ],
      genderList: [
        {
          label: '男',
          value: '0',
        },
        {
          label: '女',
          value: '1',
        }
      ],
      personTypeList: [
        {
          label: '自然人',
          value: '0',
        },
        {
          label: '法人',
          value: '1',
        },
        {
          label: '其他组织',
          value: '2',
        },
        {
          label: '其他',
          value: '3',
        }
      ],
      idTypeList: [
        {
          label: '身份证',
          value: '0',
        },
        {
          label: '临时身份证',
          value: '1',
        },
        {
          label: '户口簿',
          value: '2',
        },
        {
          label: '军官证',
          value: '3',
        },
        {
          label: '警官证',
          value: '4',
        },
        {
          label: '港澳通行证',
          value: '5',
        }
      ],
      accident: {
        latitude: 0.0,
        longitude: 0.0,
        accidentType: '', // 报警类型
        directIndemnity: '', // 是否接受直赔
        accidentPhotoList: [],
        accidentPartyList: [],
        isInsurance: [], // 保险截图列表
        accidentTime: null,
        applicable: true,
        caseDealType: null,
        crashType: null,
        id: '',
        injuredCount: null,
        policeGroupId: null,
        remark: '',
        reportPhone: '',
        status: null,
        weather: null,
        participants: [],
        accidentAddress: '',
        statementUrl: '',
        isOverpass: '', // 是否高架
        objectDestroyed: '', // 是否物损
        objectName: '', // 物损名称
        policePhone: '', // 警员电话
        policeName: '', // 警员名称
        county: '', // 行政单位
        videoUrl: '', // 视频链接
        thirdAccidentId: null
      },
      videoArr: [], // 用来存储多个视频的链接
      selectdVideo: 0, // 控制视频按钮样式
      liabilityVisible: false,
      claimVisible: false,
      timeout: null,
      isDisabled: {value: false},
      checkList: ['1'], // 报警类型
      offlineId: '', // 线下处理交警id
      OfflineBrigadeId: '', //线下处理大队id
      carLicenseType: null,
      accidentTitle: '调解详情',
      OfflinePolice: '', // 线下处理交警id
      brigadeDis: false, // 是否禁用线下大队
      policeDis: false, // 是否禁用线下交警
      tableData: [],
      currentAccidentId: '',
      uploadVisible: false,
      currentStatementUrl: '',
      dictMap: {accident_status: {}, case_deal_type: {}},
      formKeys: [],
      formValues: [],
      commonBts1: 'commonbtn selectedbtn',
      commonBts2: 'commonbtn',
      enTitle1: 'english-title en-selected',
      enTitle2: 'english-title',
      ang1: 'ang1',
      ang2: 'ang2',
      allList: false,
      statusBtns1: 'status1 status-selected',
      statusBtns2: 'status2',
      statusBtns3: 'status2',
      query: {
        accidentId: '',
        accidentStartDate: '',
        accidentEndDate: '',
      },
      rules: {
        mediationResult: [{required: true, message: '请选择调解结果'}],
        performanceMode: [{required: true, message: '请选择履行方式'}],
        amount: [{required: true, message: '请输入涉案金额'}],
      },
      personList: [],
      mainValue: {},
      accidentDate: '',
      directCompensationVisible: false,
      code2: '',
      claim2: '',
      directCompensation1: '',
      directCompensation2: '',
      directCompensation3: '',
      directCompensation1Checked: false,
      directCompensation2Checked: false,
      directCompensation3Checked: false,
      directCompensation1Disabled: false,
      directCompensation2Disabled: false,
      directCompensation3Disabled: false,
      initMediatorResult: {
        mediationResult: null,
        agreeContext: '',
        performanceMode: null,
        agreeDate: null,
        amount: null,
      },
      mediatorResult: {},
      mediatorInfo: {
        accidentInfo: {

        },
        applicantInfo: {},
        person2: {},
        respondentInfos: [],
        recordInfo: {}
      }

    }

  },
  computed: {
    currentRole() {
      return this.$store.getters.accidentRoleName
    },
    isAdd() {
      // return this.$route.name === "AccidentAdd";
      return this.$route.name === 'mediatorInfo'
    },
    isDisabledComputed() {
      if (this.isAdmin) {
        this.isDisabled.value = false
        return false
      }
      if (this.currentRole === '坐席') {
        const value = this.accident.status !== 0
        this.isDisabled.value = value
        return value
      } else {
        this.isDisabled.value = true
        return true
      }
    },
    isAdmin() {
      return this.$store.getters.isAdmin
    },
    offlineList() {
      let list =
        this.$store.getters.selecaData.length &&
        this.$store.getters.selecaData.filter(el => {
          const arr =
            el.roles &&
            el.roles.filter(role => {
              return role.roleKey === 'OfflineBrigade'
            })
          return arr && arr.length
        })
      return list
    }
  },
  watch: {
    // 报警类型转数组
    'accident.accidentType': {
      handler(val) {
        if (val) {
          this.checkList = val.split(',')
        }
      },
      immediate: true,
      deep: true
    },
    'accident.accidentPartyList': {
      handler(val) {
        if (!val.length) {
          this.accident.accidentPartyList.push({
            partyDirectIndemnity: {accidentWoundedList: [{}]}
          })
        } else {
          this.accident.accidentPartyList.forEach(el => {
            if (!el.partyDirectIndemnity) {
              this.$set(el, 'partyDirectIndemnity', {
                accidentWoundedList: [{}]
              })
            }
          })
        }
      },
      immediate: true,
      deep: true
    },
    OfflineBrigadeId(val) {
      if (val) {
        console.log(111)
        this.policeDis = true
      } else {
        console.log(222)
        this.policeDis = false
      }
    },
    OfflinePolice(val) {
      if (val) {
        console.log(111)
        this.brigadeDis = true
      } else {
        console.log(222)
        this.brigadeDis = false
      }
    },
  },
  filters: {
    typeFilter(val) {
      if (val == 0) {
        return '人民调解'
      } else {
        return '行政调解'
      }
    },
    categoryFilter(val) {
      if (val == 0) {
        return '视频调解'
      } else {
        return '线下调解'
      }
    },
    statusFilter(val) {
      if (val == 0) {
        return '待调解'
      } else if (val == 1) {
        return '调解中'
      } else {
        return '已调解'
      }
    }
  },
  created() {
    this.mediatorId = this.$route.params.id
    console.info("this.$route.params.id", this.$route.params.id)
    this.accident.id = (this.$route.params.id.length > 15 ? (this.$route.params.id.substring(10)) : (this.$route.params.id.substring(3)))
    // this.getListRole();
    if (this.$route.name === 'AccidentEdit') {
      this.accidentTitle = '调解详情'
    } else {
      this.accidentTitle = '调解详情'
    }
    this.getMediatorInfo(this.mediatorId)
  },
  methods: {

    showSmsDialog() {
      this.smsDialogVisible = true
    },
    // 去重query
    resetQuery() {
      let obj = {}
      Object.keys(this.query).forEach(key => {
        if (this.query[key]) {
          obj[key] = this.query[key]
        }
      })
      return obj
    },
    // 重置
    async reset() {
      this.query = {
        accidentId: '',
        accidentStartDate: '',
        accidentEndDate: '',
      }
      // this.getSearchTime();
      this.loading = true
      const {total, ...params} = this.pagination
      getMediatorList(params, this.resetQuery()).then(res => {
        console.log(res)
        this.tableData = res.data.list
        this.pagination.total = res.data.total
        this.loading = false
      }).catch((err) => {
        console.log(err)
      })
    },

    // 打开直赔模态框
    openDirectCompensation(id) {
      this.directCompensation1Checked = false
      this.directCompensation2Checked = false
      this.directCompensation3Checked = false
      this.directCompensation1Disabled = false
      this.directCompensation2Disabled = false
      this.directCompensation3Disabled = false
      this.directCompensationVisible = true

      getMediatorInfo(id).then(res => {
        this.directCompensationVisible = true
        console.info(res.data)
        this.mainValue = res.data
        if (null == this.mainValue || null == this.mainValue.resultDetailVO) {
          this.mediatorResult = this.initMediatorResult
        } else {
          this.mediatorResult = this.mainValue.resultDetailVO
        }
      })
    },
    getMediatorInfo(id) {
      getMediatorInfo(id).then(res => {
        console.info(res.data)
        this.mainValue = res.data
        if (null == this.mainValue || null == this.mainValue.resultDetailVO) {
          this.mediatorResult = this.initMediatorResult
        } else {
          this.mediatorResult = this.mainValue.resultDetailVO
        }
      })
    },

    directCompensationCancle() {
      this.directCompensationVisible = false
    },
    directCompensation() {
      this.mediatorResult.recordId = this.mainValue.recordId
      createMediatorResult(this.mediatorResult).then(res => {
        this.$message.success(res.msg);
      })
    },

    mediatorSubmit() {
      this.mediatorInfo.respondentInfos = [];
      this.mediatorInfo.respondentInfos.push(this.mediatorInfo.person2);
      createMediatorInfo(this.mediatorInfo).then(res => {
        this.$message.success(res.msg);
        if(200 == res.code) {
          this.getMediatorInfo(res.data);
        }
      })
    },

    // 切换视频
    changVideo(index) {
      console.log(index)
      this.selectdVideo = index
      this.accident.videoUrl = this.videoArr[index]
      this.videoUrl = this.videoArr[index]
      console.log(this.accident.videoUrl)
    }
    /**
     * 定时暂存
     */
    // timingTemp() {
    //   this.timeout = setTimeout(() => {
    //     this.tempAccident(true);
    //   }, 10000);
    // },
  }
}
</script>
<style lang="scss">
.app-container {
  height: calc(100vh - 90px);
  overflow: auto;
  //background: url("../../../assets/images/list/bgc.png") no-repeat;
  //background-size: 100% 100%;
  &::-webkit-scrollbar {
    /*定义滚动条高宽及背景
    高宽分别对应横竖滚动条的尺寸*/
    width: 0px;
    background-color: #f5f5f5;
  }

  .detailHead {
    position: fixed;
    top: 110px;
    left: 20px;
    width: 100%;
    height: 140px;
    z-index: 99;

    .title {
      margin-bottom: 20px;
    }

    .btnGroup {
      button {
        width: 160px;
        height: 48px;
        background: rgba(0, 132, 255, 0.1);
        border-radius: 4px;
        border: 1px solid #0084ff;
        color: #b1e3ff;
        font-size: 20px;
        letter-spacing: 1px;
        margin-right: 20px;
        cursor: pointer;

        img {
          margin-right: 10px;
        }
      }

      .back {
        background: rgba(255, 125, 0, 0.1);
        border: 1px solid #ff7d00;
      }

      .submit {
        background: rgba(14, 189, 53, 0.1);
        border: 1px solid #0ebd35;
      }

      .isDisabled {
        cursor: not-allowed;
      }
    }
  }

  .accident-edit {
    margin-top: 110px;
    padding-top: 15px;
    position: relative;
    display: flex;

    .el-form--inline {
      .el-form-item {
        width: 300px;
      }
    }

    // .left-content,
    // .right-content {
    //   height: 100%;
    //   margin-top: 0;
    //   overflow: auto;
    //   & > * {
    //     margin-bottom: 15px;
    //   }
    // }

    .left-content {
      width: 800px;
      position: sticky;
      top: 190px;
      display: flex;
      flex-direction: column;
      overflow: initial;
      // position: relative;
      .videolists {
        position: absolute;
        color: white;
        top: 30px;
        left: 41px;
        z-index: 100;
        display: flex;

        .changvideobtn {
          padding: 4px 10px;
          border: 1px solid #0084FF;
          background: rgba(0, 132, 255, 0.1);
          color: #B1E3FF;
          margin-left: 10px;
          cursor: pointer;
          border-radius: 4px;
        }

        .videoselected {
          background: rgba(14, 189, 53, 0.1);
          border-radius: 4px;
          border: 1px solid #0EBD35;
          color: #0EBD35;
        }
      }

      .scroll-wrapper {
        width: 1000px;
        height: 450px;
        flex: 1;
        overflow: scroll;

        &::-webkit-scrollbar {
          width: 0;
        }
      }

      .video-record,
      .stream-video {
        .header {
          width: 100%;
          display: flex;
          align-items: center;

          .header-operator-group {
            flex: 1;
            text-align: right;
            font-weight: 400;
            color: #020202;
            line-height: 17px;
            font-size: 14px;

            .info {
              cursor: pointer;

              .icon {
                color: #004dbe;
              }
            }

            :not(:last-child) {
              margin-right: 20px;
            }
          }
        }
      }
    }

    .right-content {
      flex: 1;
      width: 1000px;
      height: 700px;
      padding-top: 15px;
      margin: -15px 0 0 40px;
      overflow-x: hidden;
      overflow-y: auto;

      &::-webkit-scrollbar {
        /*定义滚动条高宽及背景
        高宽分别对应横竖滚动条的尺寸*/
        width: 6px;
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        display: block;
        width: 6px;
        margin: 0 auto;
        border-radius: 10px;
        background: #eee;
      }

      .scroll-wrapper {
        width: 1000px;
      }

      .baseInfo {
        width: 1000px;
        margin-top: 54px;

        .baseInfo-content {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          padding: 55px 80px;
        }

        .accident-info {
          // display: flex;
          // justify-content: space-between;
          font-weight: 500;
          width: 100%;
          color: #020202;

          .accident-number {
            margin: 0;
            font-size: 22px;
            line-height: 28px;
          }
        }

        .accident-status {
          width: 300px;
          font-size: 16px;
          line-height: inherit;
          color: #b1e3ff;

          img {
            vertical-align: middle;
          }

          span {
            margin-right: 15px;
          }
        }

        .applicable {
          box-shadow: 0px 2px 18px 8px rgba(0, 0, 0, 0.05);
          border-radius: 8px;
          height: 110px;
          background: #fff;
          display: flex;
          align-items: center;
          padding: 0 40px;
          font-size: 18px;
          color: #020202;
        }

        .statement {
          cursor: pointer;
          justify-content: center;
          color: #909399;
          height: 200px;
          width: 150px;
          display: flex;
          align-items: center;
          flex-direction: column;
          background: rgba(0, 0, 0, 0.04);
        }

        .operator-group {
          position: fixed;
          top: 95px;
          right: 30px;
          background-color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 999;
        }

        .alarmType {
          font-size: 16px;
          margin-bottom: 40px;
          // display: flex;
          // align-items: center;
          & > span {
            font-weight: 600;
            color: #606266;
          }
        }

        .isDispose {
          width: 100%;
          margin-bottom: 60px;

          .notApplicable {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            .el-form-item {
              width: 300px;
            }

            .offline {
              width: 300px;
              height: 48px;
              margin-top: 15px;
              line-height: 48px;
              text-align: center;
              background: rgba(14, 189, 53, 0.1);
              border-radius: 4px;
              cursor: pointer;
              font-size: 18px;
              letter-spacing: 1px;
              color: #0ebd35;
              border: 1px solid #0ebd35;
            }
          }
        }
      }

      .accidentPartys {
        width: 1000px;
        margin-top: 50px;
        background: rgba(15, 31, 70, 0.6);
      }

      .operation {
        width: 1000px;
        height: 510px;
        margin-top: 40px;
        display: flex;
        justify-content: space-between;

        .operationRecord {
          padding: 45px 20px;
          width: 500px;
          height: 510px;
        }

        .accdientRemark {
          width: 460px;
          height: 510px;
          margin-left: 40px;
          padding: 45px 20px;
          position: relative;

          .el-textarea__inner {
            width: 420px;
            height: 424px;
          }
        }
      }
    }
  }
}

.person-list {
  list-style: none;
  padding: 0;
  margin: 0;

  .role {
    line-height: 20px;

    .role-name {
      font-size: 14px;
    }

    .member-list {
      padding: 0 0 0 13px;
      margin: 0;
      list-style: none;
      font-size: 14px;
      color: #020202;

      .member {
        line-height: 20px;
      }
    }
  }
}

.operator-group {
  & > *:not(:last-child) {
    margin-right: 10px;
  }
}

.hospitalList {
  position: relative;

  .ang1 {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 150;
  }

  .ang1-other {
    position: absolute;
    top: 0;
    left: 220px;
    z-index: 150;
  }

  .ang2 {
    position: absolute;
    top: 0px;
    left: auto;
    right: 0px;
    z-index: 150;
  }

  .ang2-other {
    position: absolute;
    top: 0px;
    left: 377px;
    z-index: 150;
  }

  .ang2-2 {
    position: absolute;
    top: 78px;
    right: 0;
    z-index: 150;
  }

  .ang3 {
    position: absolute;
    bottom: 0;
    left: 0;
  }

  .ang4 {
    position: absolute;
    bottom: 0;
    right: 0;
  }

  // .maincontent {
  //   height: 796px;
  // }
  .changlistbtns {
    width: 420px;
    height: 70px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    .commonbtn {
      width: 200px;
      height: 68px;
      border: 1px solid #0084ff;
      color: #b1e3ff;
      font-size: 20px;
      margin-top: 13px;
      display: flex;
      flex-direction: column;
      text-align: center;
      background-image: linear-gradient(#0d2c60, #010345);
      cursor: pointer;

      .cn-title {
        margin-top: 13px;
      }

      .english-title {
        font-size: 12px;
        color: rgba(177, 227, 255, 0.6);
      }

      .title-selected {
        margin-top: 18px;
      }

      .en-selected {
        color: #0ebd35;
      }
    }

    .selectedbtn {
      height: 81px;
      margin-top: 0;
      color: #0ebd35;
      border-bottom: 1px solid #010345;
      z-index: 100;
    }
  }

  .listcontent {
    height: 740px;
    border: 1px solid #0084ff;
    padding-left: 20px;
    padding-right: 20px;
    background: rgba(15, 31, 70, 0.6);

    .statusbtns {
      width: 100%;
      height: 70px;
      // border: 1px solid #0084ff;
      .status1 {
        margin-top: 10px;
        width: 180px;
        height: 48px;
        border: 1px solid #0084ff;
        border-radius: 4px;
        text-align: center;
        line-height: 48px;
        font-size: 20px;
        color: #b1e3ff;
        float: left;
        cursor: pointer;
      }

      .status2 {
        margin-top: 10px;
        width: 160px;
        height: 48px;
        border: 1px solid #0084ff;
        border-radius: 4px;
        margin-left: 10px;
        color: #b1e3ff;
        font-size: 20px;
        text-align: center;
        line-height: 48px;
        float: left;
        cursor: pointer;
      }

      .status-selected {
        border: 1px solid #0ebd35;
        //background: url("../assets/images/list/status-selected.png") no-repeat top right;
        color: #0ebd35;
      }
    }

    .searchform {
      height: 190px;
      display: flex;
      justify-content: space-between;
      border-top: 1px solid #0084ff;

      .searchitem1 {
        width: 300px;
        margin-top: -10px;
        display: flex;
        flex-direction: column;

        .searchitem1-laber {
          margin-top: 20px;
          margin-bottom: 10px;
          font-size: 12px;
          color: #17ecfe;
        }

        .searchbtns {
          width: 400px;
          height: 36px;
          margin-top: 16px;

          .search-btn {
            border: 1px solid #0ebd35;
            color: #0ebd35;
            background-color: rgba(14, 189, 53, 0.1);
          }

          .reset-btn {
            background-color: rgba(0, 132, 255, 0.1);
            color: #b1e3ff;
            margin: 0 15px;
          }

          .more-btn {
            background-color: rgba(0, 132, 255, 0.1);
            color: #b1e3ff;
          }
        }

        .searchinput {
          // border: 1px solid #0084ff;
          background-color: transparent !important;
        }

        .el-input--medium .el-input__inner {
          // background-color: transparent;
          // color: #b1e3ff !important;
        }
      }

      .searchitem2 {
        width: 400px;
      }
    }

    // .el-table__empty-block {
    //   height: 500px!important;
    // }
  }

  .myDialog .logContent .logMain {
    max-height: 450px;
    overflow-y: auto;
  }

  .processcontent .proBtns {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    margin: 0 auto;
    width: 340px;
    height: 48px;
    margin-top: 30px;
    bottom: 0;
  }

  .processcontent .proBtns .proCancle {
    cursor: pointer;
    width: 158px;
    height: 46px;
    border: 1px solid #0084ff;
    background: rgba(0, 132, 255, 0.1);
    font-size: 20px;
    line-height: 46px;
    text-align: center;
    color: #b1e3ff;
    border-radius: 4px;
  }

  .processcontent .proBtns .proConfire {
    cursor: pointer;
    width: 158px;
    height: 46px;
    border: 1px solid #0ebd35;
    background: rgba(14, 189, 53, 0.1);
    border-radius: 4px;
    font-size: 20px;
    line-height: 46px;
    text-align: center;
    color: #0ebd35;
  }
}
</style>
